/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Total
 */
export interface Total {
}

/**
 * Check if a given object implements the Total interface.
 */
export function instanceOfTotal(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TotalFromJSON(json: any): Total {
    return TotalFromJSONTyped(json, false);
}

export function TotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): Total {
    return json;
}

export function TotalToJSON(value?: Total | null): any {
    return value;
}

